import { render, staticRenderFns } from "./ayFoot.vue?vue&type=template&id=23280ba5&"
import script from "./ayFoot.vue?vue&type=script&lang=js&"
export * from "./ayFoot.vue?vue&type=script&lang=js&"
import style0 from "./ayFoot.vue?vue&type=style&index=0&id=23280ba5&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports